module.exports = __webpack_public_path__ + "static/sungjinhong-e68449180293edd750798be8ec5401fa.jpeg";